import { onboardingService } from "../../core/service/services";
import type { OnboardingDocument } from "./onboarding";

/**
 * Un champ se redessine souvent et le document, lui, ne bouge plus : sans ce cache la fiche est
 * redemandée à chaque rendu. Partagé, parce que le web et le mobile ont le même besoin.
 */
const described = new Map<string, Promise<OnboardingDocument>>();

export function describeDocument(documentId: string): Promise<OnboardingDocument> {
  const known = described.get(documentId);
  if (known) {
    return known;
  }

  const pending = onboardingService.getDocument(documentId);
  described.set(documentId, pending);
  // Un échec ne se met pas en cache, sinon le champ reste muet jusqu'au prochain lancement.
  pending.catch(() => described.delete(documentId));

  return pending;
}
